/* eslint-disable react/jsx-no-target-blank */
import { Button } from "antd";
import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { objectiveContext } from "../../../context/Objective";
import Layout from "../Layout/Layout";

const data = [
  {
    id: 1,
    count: "01",
    heading: "SMART CITIES",
    route: "smart-cities",
    title: "Put insights into action",
    bgImg: "bg-[url(/public/assets/smartcity.jpg)]",
    imgSrc: "/assets/smartcity.jpg",
    desc: `By 2025, 70% of global cities will have a digital twin. With the increase in Urbanization it is
critical for smart cities to be able to lower greenhouse gas emissions by leveraging digital twin
technologies. IoT sensors collect critical data such as mobility, pollution, water levels and
shadow impacts to help municipal authorities make critical decisions to increase livability and at
the same time reduce carbon emissions. Taking this information and connecting it to the
MetaWorldX Digital Twin allows cities to put insights into action.
`,
  },
  {
    id: 2,
    count: "02",
    heading: "CRITICAL INFRASTRUCTURE",
    route: "critical-infrastructure",
    title: `Putting digital twins to work`,
    bgImg: "bg-[url(/public/assets/criticalinfrastructure.jpg)]",
    imgSrc: "/assets/criticalinfrastructure.jpg",
    desc: `You have the data, now it’s time to take it to the next level. MetaWorldX Digital Twin solutions
help connect live asset information to a front end visualization platform. This technology can
help increase asset value, share information, training, simulations, and help with historic live
data and predictive analysis. Giving engineers and asset managers the power of connectivity
can help reduce risk and minimize carbon emissions.

`,
  },
  {
    id: 3,
    count: "03",
    heading: "REAL ESTATE",
    title: `Seeing is Believing`,
    route: "real-estate",
    bgImg: "bg-[url(/public/assets/realestate.jpg)]",
    imgSrc: "/assets/realestate.jpg",
    desc: `The most innovative and breathtaking real estate projects in the world rely on creating a
captivating and accurate representation of a future project. MetaWorldX helps property
developers by taking their architectural files and creating a live 3D application for a quicker
permit approval process. When it comes to sales and marketing, MetaWorldX creates 1:1 scale
models ready for digital presentations of a project's interiors, exteriors, amenities, urban
environment, shadow impacts and everything buyers and investors need to see to fall in love
with the project. This includes but is not limited to renderings, walkthrough videos, cinematic 4K
commercials and much more.

`,
  },
  {
    id: 4,
    count: "04",
    heading: "CYBER SECURITY",
    route: "cyber-security",
    title: `Security Services for the Metaverse`,
    bgImg: "bg-[url(/public/assets/cybersecurity.jpg)]",
    imgSrc: "/assets/cybersecurity.jpg",
    desc: `With the growth of digitalization and creation of the metaverse, companies are becoming more
concerned with their security on these online platforms. Cyber criminals are exploiting the
unknown and unregulated nature of the metaverse to attack organizations and exploit
individuals. MetaWorldX has partnered with the top organizations in the cybersecurity space to
ensure a safe, secure transition into the metaverse.`,
  },
  {
    id: 5,
    count: "05",
    heading: "HEALTH CARE",
    route: "health-care",
    title: ` Revolutionizing the Healthcare Industry`,
    bgImg: "bg-[url(/public/assets/healthcare.png)]",
    imgSrc: "/assets/healthcare.png",
    desc: `Using live data, AI and digital twin technology, doctors and practitioners can help reduce wait
times, increase efficiencies and share information with other clinicians securely and efficiently.
MetaWorldX partners with hospitals, practitioners, rehabilitation clinics, dieticians and physical
training facilities to provide the ultimate holistic healthcare experience in the digital era.
`,
  },
];

function SubCategories() {
  const { setCompanyActive, setSolutionActive } = useContext(objectiveContext);
  const { subCat } = useParams();
  return (
    <Layout>
      {data
        .filter((f) => f.route === subCat)
        .map((item) => {
          return (
            <div
              onClick={() => {
                setSolutionActive(false);
                setCompanyActive(false);
              }}
              className="h-full mt-[100px] mb-[45px] flex flex-col justify-center items-center text-center"
            >
              <div className="text-5xl font-bold text-[#ffffff] z-10 max-[500px]:text-3xl mt-[10px] mb-[40px]">
                {item.heading}
              </div>
              <div className="flex w-full items-center justify-center">
                <div className="w-[100%] flex items-center justify-center">
                  <img
                    style={{ objectFit: "cover" }}
                    src={item.imgSrc}
                    width="100%"
                    height="100%"
                    alt=""
                  />
                </div>
              </div>
              <div className="text-[30px] text-[#ffffff] capitalize font-bold max-[481px]:text-[18px] text-center py-[10px]">
                {item.title}
              </div>
              <div className="text-[18px] px-[20px] text-[#ffffff] font-normal max-[481px]:text-[14px] text-justify">
                {item.desc}
              </div>
              <div className="mt-[20px]">
                <a
                  href="https://calendly.com/razametaworldx/30min"
                  target="_blank"
                >
                  <Button type="primary">LETS GET DIGITAL</Button>
                </a>
              </div>
            </div>
          );
        })}
    </Layout>
  );
}

export default SubCategories;
